module.exports = __webpack_public_path__ + "static/media/12.422c920e.jpg";